import { CognitoIdentityProviderClient } from '@aws-sdk/client-cognito-identity-provider';
import { AWS_REGION } from '@shared/configs/client-env-file';

export const cognitoIdentityProviderClient = new CognitoIdentityProviderClient({
  region: AWS_REGION,
});